import _lib from '../_lib';
import active from './active/index';
import {VitalsGroup} from '@/store/modules/fsm/messages';
import { clearAllWatches } from '@/mutation-types';;

export default ({tree,parent,api}) => {
  let regionName = 'vitalsGroup';
  let activations = [
    {
      name: 'vitalsGroup',
      test: api.messageIs(VitalsGroup)
    }
  ];
  let activeIndex = active;
  let readyToDormant = ({context}) => context.commit(`login/watch/${clearAllWatches}`,null,{root:true}); //might need to change getter
  let func = _lib({regionName,activations,activeIndex,readyToDormant});
  return func({tree,parent,api});
};